export default "__VITE_ASSET__DVFRQDge__"